import { html, type Html, Page, View } from 'rune-ts';
import { PlusShopTypeS } from '../../../features/PlusShop/outbound/share';
import { makeEmptyScreenNavigate } from '../../../shared/app/navigate';
import { dataStr } from '../../../shared/util/dataStr';
import { ArrowRightIcon } from '../../components/atoms/Icon';
import { footer_links } from '../../components/cells/Footer/constant';
import { LayoutView } from '../../components/cells/Layout/LayoutView';
import { PlusShopCard } from '../../components/cells/PlusShopCard/PlusShopCard';
import klass from './AllPlusShop.module.scss';
import { BaseLayoutOptions } from '../../../features/Core/service';
import { type ProductCardData } from '../../../features/ProductList/type';
import { FloatingButton_recent_product } from '../../components/cells/FloatingBox/FloatingButtons/FloatingButton_recent_product';
import { FloatingBox } from '../../components/cells/FloatingBox/FloatingBox';
import { CoreUiS } from '../../../features/Core/outbound/share';
import { font } from '@services/MarppleShop/shared/typography';
import { Tooltip } from '@services/MarppleShop/renderApp/components/atoms/Tooltip/Tooltip.ts';

export type AllPlusShopPageData = {
  plus_shop_list: PlusShopTypeS.PlusShopCardType[];
  layout_options: BaseLayoutOptions;
  recent_product?: ProductCardData;
  adult_check_needed: boolean;
};

class AllPlusShopBody extends View<AllPlusShopPageData> {
  tooltip = () => {
    const txt1 = ET('mps2::creator::plus::tooltip');
    const txt2 = ET('mps2::creator::plus::tooltip_link');
    return html`
      <div class="${klass.tooltip}">
        <p class="${font('14_medium')}">${html.preventEscape(txt1)}</p>
        <a
          href="/${ET.lang}/@/plus"
          target="_blank"
          data-post-message="${dataStr(makeEmptyScreenNavigate(`/${ET.lang}/@/plus`))}"
          class="${klass.tooltip_link} ${font('16_bold')}"
        >
          ${html.preventEscape(txt2)} ${ArrowRightIcon}
        </a>
      </div>
    `;
  };

  protected override template() {
    const {
      layout_options: { is_mobile },
      plus_shop_list,
      adult_check_needed,
    } = this.data;

    return html`
      <div class="${klass.container}">
        <div class="${klass.title}">
          ${CoreUiS.makeCreatorRankingTitle(
            is_mobile,
            'plus_shop',
            new Tooltip({
              id: 'plus_shop_info',
              content: this.tooltip(),
            }),
          )}
        </div>

        <div class="${klass.creator_plus}">
          <div class="${klass.list}">
            ${plus_shop_list.map((plus_shop) => new PlusShopCard(plus_shop, { adult_check_needed }))}
          </div>
        </div>
      </div>
    `;
  }
}

export class AllPlusShopPage extends Page<AllPlusShopPageData> {
  protected override template(data: AllPlusShopPageData): Html {
    const { layout_options } = data;

    return html`
      <div class="${klass.page}">
        ${new LayoutView(
          {
            body: new AllPlusShopBody(this.data),
            footer_data: { ...footer_links, is_mobile: layout_options.is_mobile, lang: ET.lang },
          },
          {
            ...layout_options,
            has_bottom_tab_bar: true,
            selected_bottom_tab_idx: 1,
            floating_box: {
              recent_product: FloatingButton_recent_product.makeProps(this.data.recent_product),
              async renderHook(view: FloatingBox) {
                await FloatingBox.refreshRecentProductFloatingButton(view);
              },
            },
          },
        )}
      </div>
    `;
  }
}
